"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var react_popper_1 = require("react-popper");
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var pixel_calc_1 = require("../../_helpers/pixel-calc");
var uniqueId_1 = __importDefault(require("../../_helpers/uniqueId"));
var tokens_1 = require("../../tokens");
var arrowWidth = '6px';
var arrowColor = tokens_1.colors.tooltip.background;
var arrowAdjustment = pixel_calc_1.multiply(arrowWidth, -2);
var Tooltip = (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip(props) {
        var _this = _super.call(this, props) || this;
        _this.showTooltip = function () {
            _this.setState({ visible: true });
        };
        _this.hideTooltip = function () {
            if (_this.props.defaultVisible) {
                return;
            }
            _this.setState({ visible: false });
        };
        _this.onKeyDown = function (event) {
            if (event.key === 'Escape') {
                _this.setState({ visible: false });
            }
        };
        _this.state = {
            visible: props.defaultVisible || false,
            id: props.id || uniqueId_1.default('tooltip')
        };
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, content = _a.content, props = __rest(_a, ["content"]);
        var id = this.state.id;
        var child;
        if (React.Children.count(props.children) === 1 && React.isValidElement(props.children)) {
            child = React.cloneElement(props.children, { 'aria-describedby': id });
        }
        else {
            child = props.children;
        }
        return (React.createElement(react_popper_1.Manager, null,
            React.createElement(react_popper_1.Reference, null, function (_a) {
                var ref = _a.ref;
                return (React.createElement(Tooltip.Trigger, __assign({ onMouseEnter: _this.showTooltip, onFocus: _this.showTooltip, onMouseLeave: _this.hideTooltip, onBlur: _this.hideTooltip, innerRef: ref, onKeyDown: _this.onKeyDown }, automation_attribute_1.default('tooltip.trigger')), child));
            }),
            React.createElement(react_popper_1.Popper, { placement: props.position, positionFixed: true, modifiers: {
                    preventOverflow: { enabled: false },
                    hide: { enabled: false },
                    offset: { offset: '0, 10' }
                } }, function (_a) {
                var ref = _a.ref, style = _a.style, placement = _a.placement, arrowProps = _a.arrowProps, scheduleUpdate = _a.scheduleUpdate;
                return (React.createElement(React.Fragment, null, _this.state.visible ? (React.createElement(Tooltip.ObservedElement, __assign({ scheduleUpdate: scheduleUpdate, innerRef: ref, style: __assign({ zIndex: 20 }, style), "data-placement": placement, id: id }, automation_attribute_1.default('tooltip'), props),
                    content,
                    React.createElement(Tooltip.Arrow, { "data-placement": placement, innerRef: arrowProps.ref, style: arrowProps.style }))) : null));
            })));
    };
    Tooltip.ObservedElement = (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        class_1.prototype.componentDidUpdate = function () {
            this.props.scheduleUpdate();
        };
        class_1.prototype.render = function () {
            return React.createElement(Tooltip.Element, __assign({}, this.props));
        };
        return class_1;
    }(React.Component));
    Tooltip.Element = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    color: ", ";\n    border-radius: ", ";\n    width: max-content;\n    text-align: center;\n    padding: ", ";\n    line-height: ", ";\n    font-size: 13px;\n    pointer-events: none;\n    max-width: 260px;\n  "], ["\n    background: ", ";\n    color: ", ";\n    border-radius: ", ";\n    width: max-content;\n    text-align: center;\n    padding: ", ";\n    line-height: ", ";\n    font-size: 13px;\n    pointer-events: none;\n    max-width: 260px;\n  "])), tokens_1.colors.tooltip.background, tokens_1.colors.tooltip.text, tokens_1.misc.radius, tokens_1.spacing.xsmall, tokens_1.misc.lineHeight);
    Tooltip.Trigger = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-block;\n    position: relative;\n  "], ["\n    display: inline-block;\n    position: relative;\n  "])));
    Tooltip.Arrow = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    width: 0;\n    height: 0;\n\n    &::before {\n      content: '';\n      margin: auto;\n      display: block;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      border-width: ", ";\n      border-color: transparent;\n    }\n\n    &[data-placement*='top'] {\n      bottom: 0;\n      margin-left: ", ";\n\n      &::before {\n        border-bottom-width: 0;\n        border-top-color: ", ";\n      }\n    }\n\n    &[data-placement*='right'] {\n      left: 0;\n      margin-top: ", ";\n      margin-left: -", ";\n      &::before {\n        border-left-width: 0;\n        border-right-color: ", ";\n      }\n    }\n\n    &[data-placement*='bottom'] {\n      top: 0;\n      left: 0;\n      margin-left: ", ";\n      margin-top: -", ";\n      &::before {\n        border-top-width: 0;\n        border-bottom-color: ", ";\n      }\n    }\n\n    &[data-placement*='left'] {\n      right: 0;\n      margin-top: ", ";\n      &::before {\n        border-right-width: 0;\n        border-left-color: ", ";\n      }\n    }\n  "], ["\n    position: absolute;\n    width: 0;\n    height: 0;\n\n    &::before {\n      content: '';\n      margin: auto;\n      display: block;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      border-width: ", ";\n      border-color: transparent;\n    }\n\n    &[data-placement*='top'] {\n      bottom: 0;\n      margin-left: ", ";\n\n      &::before {\n        border-bottom-width: 0;\n        border-top-color: ", ";\n      }\n    }\n\n    &[data-placement*='right'] {\n      left: 0;\n      margin-top: ", ";\n      margin-left: -", ";\n      &::before {\n        border-left-width: 0;\n        border-right-color: ", ";\n      }\n    }\n\n    &[data-placement*='bottom'] {\n      top: 0;\n      left: 0;\n      margin-left: ", ";\n      margin-top: -", ";\n      &::before {\n        border-top-width: 0;\n        border-bottom-color: ", ";\n      }\n    }\n\n    &[data-placement*='left'] {\n      right: 0;\n      margin-top: ", ";\n      &::before {\n        border-right-width: 0;\n        border-left-color: ", ";\n      }\n    }\n  "])), arrowWidth, arrowAdjustment, arrowColor, arrowAdjustment, arrowWidth, arrowColor, arrowAdjustment, arrowWidth, arrowColor, arrowAdjustment, arrowColor);
    Tooltip.defaultProps = {
        content: null,
        position: 'top',
        defaultVisible: false
    };
    return Tooltip;
}(React.Component));
exports.default = Tooltip;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=tooltip.js.map